import { useUserTeams } from '@common/projectHooks';
import { createContext, useEffect, useState } from 'react';
import { useSearchParams } from 'react-router-dom';

import { useUser } from '../../context/user';
import { TeamKind } from '../../graphqlTypes/enums';

export const ActiveTeamContext = createContext<{ activeTeamId: string; setActiveTeamId: (teamId: string) => void }>({
  activeTeamId: '',
  setActiveTeamId: () => {}
});

export const ActiveTeamProvider = ({ children }: { children: React.ReactNode }) => {
  const [activeTeamId, setActiveTeamId] = useState<string>('');
  const { data: teams } = useUserTeams();
  const { user } = useUser();
  const [searchParams] = useSearchParams();

  const teamIdFromSearchParams = searchParams.get('teamId');

  useEffect(() => {
    if (teamIdFromSearchParams) {
      setActiveTeamId(teamIdFromSearchParams);
      return;
    }

    // if the team is personal and the user is the creator, then only set the active team id
    const userPersonalTeamId = teams?.find(
      (team) => team.teamKind === TeamKind.ProphecyManagedPersonal && team.createdBy === user?.id
    )?._id;
    if (userPersonalTeamId) {
      setActiveTeamId(userPersonalTeamId);
      return;
    }

    // Ideally this will never happen as personal team cannot be deleted by the user, however falling back to the first team in case it does
    setActiveTeamId(teams?.[0]?._id || '');
  }, [teams, setActiveTeamId, teamIdFromSearchParams, user?.id]);

  return <ActiveTeamContext.Provider value={{ activeTeamId, setActiveTeamId }}>{children}</ActiveTeamContext.Provider>;
};
